import { axios } from "@/axios"
import { Media } from "@/models"

export async function editMedia(media: Media, eventVaultId?: number) {
  if (!eventVaultId) {
    throw new Error(
      "Missing `eventVaultId` when attempting to favourite media. Please ensure `eventVaultId` is provided.",
    )
  }

  const response = await axios.put(`api/guest/${eventVaultId}/media`, Media.toRequest(media))

  return Media.fromResponse(response?.data.Data)
}
